import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "common-subtitle" }
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = {
  key: 0,
  class: "subtitle-icon"
}
const _hoisted_4 = { class: "contents-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.icon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.icon), 1))
        : _createCommentVNode("", true),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.text), 1)
    ])
  ]))
}